import "./production.css"
import { Card, Image } from "antd"
function Production(){
    const { Meta } = Card;
    
    const cloths = [
        
        { sort:1, alt:'JF-TJ224', src:require('../../../assets/images/shows-images/JF-TJ224.png') },
        { sort:2, alt:'JF-L011', src:require('../../../assets/images/shows-images/JF-L011.png') },
        { sort:3, alt:'JF-TJ219', src:require('../../../assets/images/shows-images/JF-TJ219.png') },
        { sort:4, alt:'JF-TJ187', src:require('../../../assets/images/shows-images/JF-TJ187.png') },
        { sort:5, alt:'LC2401', src:require('../../../assets/images/shows-images/LC2401.png') },
        { sort:6, alt:'AJ001', src:require('../../../assets/images/shows-images/AJ001.png') },
        { sort:7, alt:'JF048', src:require('../../../assets/images/shows-images/JF048.png') },
        { sort:8, alt:'JF115', src:require('../../../assets/images/shows-images/JF115.png') },
        { sort:9, alt:'JF-Z016', src:require('../../../assets/images/shows-images/JF-Z016.png') },
        { sort:10, alt:'JYYHF018', src:require('../../../assets/images/shows-images/JYYHF018.png') },
        { sort:11, alt:'JF-TJ212', src:require('../../../assets/images/shows-images/JF-TJ212.png') },
        { sort:12, alt:'JF-TL028', src:require('../../../assets/images/shows-images/JF-TL028.png') },
        { sort:13, alt:'JF-L018', src:require('../../../assets/images/shows-images/JF-L018.png') },
        { sort:14, alt:'JF-TJ181', src:require('../../../assets/images/shows-images/JF-TJ181.png') },
        { sort:15, alt:'JF-TJ130', src:require('../../../assets/images/shows-images/JF-TJ130.png') },
        { sort:16, alt:'JF-TJ079', src:require('../../../assets/images/shows-images/JF-TJ079.png') },
        { sort:17, alt:'JF-TJ209', src:require('../../../assets/images/shows-images/JF-TJ209.png') },
        { sort:18, alt:'JF-TL026', src:require('../../../assets/images/shows-images/JF-TL026.png') },
        { sort:19, alt:'JF-TL072', src:require('../../../assets/images/shows-images/JF-TL072.png') },
        { sort:20, alt:'LL25813', src:require('../../../assets/images/shows-images/LL25813.png') },
        { sort:21, alt:'JF-TL068', src:require('../../../assets/images/shows-images/JF-TL068.png') },
        { sort:22, alt:'JF-TJ147', src:require('../../../assets/images/shows-images/JF-TJ147.png') },
        { sort:23, alt:'JK004', src:require('../../../assets/images/shows-images/JK004.png') },
        { sort:24, alt:'JF-TJ189', src:require('../../../assets/images/shows-images/JF-TJ189.png') },
        { sort:25, alt:'LY2527', src:require('../../../assets/images/shows-images/LY2527.png') },
        { sort:26, alt:'JF-TJ188', src:require('../../../assets/images/shows-images/JF-TJ188.png') },
        { sort:27, alt:'JF-TL067', src:require('../../../assets/images/shows-images/JF-TL067.png') },
        { sort:28, alt:'JF-TJ225', src:require('../../../assets/images/shows-images/JF-TJ225.png') },
        { sort:29, alt:'JF-TJ078', src:require('../../../assets/images/shows-images/JF-TJ078.png') },
        { sort:30, alt:'JF-TJ190', src:require('../../../assets/images/shows-images/JF-TJ190.png') },
        { sort:31, alt:'JYYHF013', src:require('../../../assets/images/shows-images/JYYHF013.png') },
        { sort:32, alt:'JF-TL022', src:require('../../../assets/images/shows-images/JF-TL022.png') },
        { sort:33, alt:'JF-L049', src:require('../../../assets/images/shows-images/JF-L049.png') },
        { sort:34, alt:'JF-Y022', src:require('../../../assets/images/shows-images/JF-Y022.png') },
        { sort:35, alt:'JF-Z041', src:require('../../../assets/images/shows-images/JF-Z041.png') },
        { sort:36, alt:'JF-TJ216', src:require('../../../assets/images/shows-images/JF-TJ216.png') },
        { sort:37, alt:'JF-Z026', src:require('../../../assets/images/shows-images/JF-Z026.png') },
        { sort:38, alt:'JF-TJ193-ALL', src:require('../../../assets/images/shows-images/JF-TJ193-ALL.png') },
        { sort:39, alt:'JF-L007', src:require('../../../assets/images/shows-images/JF-L007.png') },
        { sort:40, alt:'JF-TJ196', src:require('../../../assets/images/shows-images/JF-TJ196.png') },
        { sort:41, alt:'JF-L009', src:require('../../../assets/images/shows-images/JF-L009.png') },
        { sort:42, alt:'JF-TJ176', src:require('../../../assets/images/shows-images/JF-TJ176.png') },
        { sort:43, alt:'JF-TJ178', src:require('../../../assets/images/shows-images/JF-TJ178.png') },
        { sort:44, alt:'WLC003', src:require('../../../assets/images/shows-images/WLC003.png') },
        { sort:45, alt:'JF028', src:require('../../../assets/images/shows-images/JF028.png') },
        { sort:46, alt:'JF030', src:require('../../../assets/images/shows-images/JF030.png') },
        { sort:47, alt:'AJ005', src:require('../../../assets/images/shows-images/AJ005.png') },
        { sort:48, alt:'JF077', src:require('../../../assets/images/shows-images/JF077.png') },
        { sort:49, alt:'JF-TL007', src:require('../../../assets/images/shows-images/JF-TL007.png') },
        { sort:50, alt:'JF-TJ186', src:require('../../../assets/images/shows-images/JF-TJ186.png') },
        { sort:51, alt:'JF-TJ215', src:require('../../../assets/images/shows-images/JF-TJ215.png') },
        { sort:52, alt:'HZJ010', src:require('../../../assets/images/shows-images/HZJ010.png') },
        { sort:53, alt:'JF050', src:require('../../../assets/images/shows-images/JF050.png') },
        { sort:54, alt:'JK009', src:require('../../../assets/images/shows-images/JK009.png') },
        { sort:55, alt:'JK003', src:require('../../../assets/images/shows-images/JK003.png') },
        { sort:56, alt:'JK002', src:require('../../../assets/images/shows-images/JK002.png') },
        { sort:57, alt:'JF-TJ197', src:require('../../../assets/images/shows-images/JF-TJ197.png') },
        { sort:58, alt:'JF-TJ201', src:require('../../../assets/images/shows-images/JF-TJ201.png') },
        { sort:59, alt:'JF-TJ203', src:require('../../../assets/images/shows-images/JF-TJ203.png') },
        { sort:60, alt:'JF-TJ220', src:require('../../../assets/images/shows-images/JF-TJ220.png') },
        { sort:61, alt:'JF-TJ221', src:require('../../../assets/images/shows-images/JF-TJ221.png') },
        { sort:62, alt:'JF-TJ230', src:require('../../../assets/images/shows-images/JF-TJ230.png') },
        { sort:63, alt:'JH018', src:require('../../../assets/images/shows-images/JH018.png') },
        { sort:64, alt:'WX007-T', src:require('../../../assets/images/shows-images/WX007-T.png') },
        { sort:65, alt:'JYYHF002', src:require('../../../assets/images/shows-images/JYYHF002.png') },
        { sort:66, alt:'JYYHF012', src:require('../../../assets/images/shows-images/JYYHF012.png') },
        { sort:67, alt:'JF-TJ076', src:require('../../../assets/images/shows-images/JF-TJ076.png') },
        { sort:68, alt:'JF-TJ179', src:require('../../../assets/images/shows-images/JF-TJ179.png') },
        { sort:69, alt:'JF-TJ061', src:require('../../../assets/images/shows-images/JF-TJ061.png') },
        { sort:70, alt:'JF-TJ192-ALL', src:require('../../../assets/images/shows-images/JF-TJ192-ALL.png') },
        { sort:71, alt:'JF-TJ198', src:require('../../../assets/images/shows-images/JF-TJ198.png') },
        { sort:72, alt:'LL2517', src:require('../../../assets/images/shows-images/LL2517.png') },
        { sort:73, alt:'JF-Z027', src:require('../../../assets/images/shows-images/JF-Z027.png') },
        { sort:74, alt:'JF-TJ060', src:require('../../../assets/images/shows-images/JF-TJ060.png') },
        { sort:75, alt:'AJ008', src:require('../../../assets/images/shows-images/AJ008.png') },
        { sort:76, alt:'JF130', src:require('../../../assets/images/shows-images/JF130.png') },
        { sort:77, alt:'JF120', src:require('../../../assets/images/shows-images/JF120.png') },
        { sort:78, alt:'JYYHF007', src:require('../../../assets/images/shows-images/JYYHF007.png') },
        { sort:79, alt:'JF-TL012', src:require('../../../assets/images/shows-images/JF-TL012.png') },
        { sort:80, alt:'JF-TJ185', src:require('../../../assets/images/shows-images/JF-TJ185.png') },
        { sort:81, alt:'JF-TJ059', src:require('../../../assets/images/shows-images/JF-TJ059.png') },
        { sort:82, alt:'JF-TJ156', src:require('../../../assets/images/shows-images/JF-TJ156.png') },
    ]

    // const topsCloths = cloths.filter(item => {
    //     return item.level === 1
    // })
    // const dressesCloths = cloths.filter(item => {
    //     return item.level === 2
    // })
    // const othersCloths = cloths.filter(item => {
    //     return item.level === 3
    // })


    // const menus = [
    //     { name:'Tops',level:1 },
    //     { name:'Dresses',level:2 },
    //     { name:'Pants & Sets & Others',level:3 }
    // ]

    return <div className="production" id="production-3">
        <div className="title">
            PRODUCTS
            <section>Price and more styles, please contact us!</section>
        </div>
        <div className="imgs">
            <section>
                {
                    cloths.map(item => {
                        return <Card
                            className="items"
                            key={ item.src }
                            cover={
                                <Image.PreviewGroup>
                                <Image alt={ item.alt } src={ item.src }/>
                            </Image.PreviewGroup>
                            }
                        >
                            <Meta title={ item.alt } />
                        </Card>
                    })
                }
                {/* {
                    menus.map((item, index) => {
                        return <div key={ index+item.name }>
                            <div className="clothestype-name" key={ item.name }>
                                { item.name }
                            </div>
                            <div className="chothestype-item">
                                { 
                                    item.level === 1 ? topsCloths.map(item => {
                                        return <Card
                                            className="items"
                                            key={ item.src }
                                            cover={
                                                <Image.PreviewGroup>
                                                <Image alt={ item.alt } src={ item.src }/>
                                            </Image.PreviewGroup>
                                            }
                                        >
                                            <Meta title={ item.alt } />
                                        </Card>
                                    }) : 
                                    (
                                        item.level === 2 ? dressesCloths.map(item => {
                                            return <Card
                                            className="items"
                                            key={ item.src }
                                            cover={
                                                <Image.PreviewGroup>
                                                <Image alt={ item.alt } src={ item.src }/>
                                            </Image.PreviewGroup>
                                            }
                                        >
                                            <Meta title={ item.alt } />
                                        </Card>
                                        }) : 
                                        othersCloths.map(item => {
                                            return <Card
                                            className="items"
                                            key={ item.src }
                                            cover={
                                                <Image.PreviewGroup>
                                                <Image alt={ item.alt } src={ item.src }/>
                                            </Image.PreviewGroup>
                                            }
                                        >
                                            <Meta title={ item.alt } />
                                        </Card>
                                        })
                                    )
                                }
                            </div>
                        </div>
                    })
                } */}
            </section>
            {/* <section className="left">
                {
                    menus.map((item,index) => {
                        return <div onClick={ () => {changeMenu(item,index)} } className={ Index === index+1 ? 'lineHeightColor' : '' } key={ item.name+index }>{ item.name }</div>
                    })
                }
            </section> */}
            {/* <ul className="right">
                {
                    clothsCopy.map((item,index) => {
                        return <li className="list-item" key={ item.alt+index }>
                            <Image.PreviewGroup>
                                <Image alt={ item.alt } src={ item.src }/>
                                <div>{ item.alt }</div>
                            </Image.PreviewGroup>
                        </li>
                    })
                }
            </ul> */}
        </div>
    </div>
}

export default Production;